import React from 'react';
import { Link } from 'react-router-dom';

// Nothing has been imported at all.
export function NoCompanies() {
  return (
    <div className="rounded-lg border border-gray-200 bg-white px-6 py-12 text-center">
      <p className="text-gray-900 font-semibold">No companies yet</p>
      <p className="text-sm text-gray-500 mt-1">
        Import your ATS records and SignalCue will work out which companies are worth watching.
      </p>
      <Link
        to="/admin/data"
        className="inline-block mt-4 px-4 py-2 text-sm font-semibold rounded-lg bg-[#00C6AE] text-white hover:bg-[#00b09b]"
      >
        Go to Data
      </Link>
    </div>
  );
}

// The tenant has companies, but none match the current filter.
export function NoneInThisView({ show }) {
  const message = {
    monitoring: 'You are not monitoring any companies yet. Work the proposals above to start.',
    unwatched: 'Every company you have is being monitored.',
    all: 'No companies match.',
  }[show] || 'No companies match.';
  return (
    <div className="rounded-lg border border-gray-200 bg-white px-6 py-10 text-center text-sm text-gray-500">
      {message}
    </div>
  );
}

// LoadingCompanies is what the list shows while a NEW filter is being fetched.
//
// Without it the previous filter's rows stayed on screen for the length of the
// request, so choosing 'Not watched' looked like a tab that did nothing — the most
// expensive kind of bug, because the user's next move is to click it again.
//
// Rows rather than a spinner: the shape of what is coming is itself information,
// and a list that keeps its height does not shove the page around when it lands.
export function LoadingCompanies({ rows = 6 }) {
  return (
    <div data-testid="company-list-skeleton" className="divide-y divide-gray-100"
      role="status" aria-label="Loading companies">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 px-4 py-3.5">
          <span className="w-2 h-2 rounded-full bg-gray-200 shrink-0" />
          <span className="flex-1 min-w-0">
            {/* Varied widths so it reads as text rather than as a loading bar. */}
            <span className="block h-3.5 rounded bg-gray-200 animate-pulse"
              style={{ width: `${[38, 52, 30, 46, 60, 34][i % 6]}%` }} />
            <span className="block h-2.5 mt-1.5 rounded bg-gray-100 animate-pulse"
              style={{ width: `${[62, 44, 70, 50, 38, 56][i % 6]}%` }} />
          </span>
          <span className="w-8 h-5 rounded-full bg-gray-200 shrink-0 animate-pulse" />
        </div>
      ))}
    </div>
  );
}
